import { render, staticRenderFns } from "./EditBillingChangeRequest.vue?vue&type=template&id=4354ece9"
import script from "./EditBillingChangeRequest.vue?vue&type=script&lang=ts"
export * from "./EditBillingChangeRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports